/*
 * HobbyGundam: live kit cards inside guide articles (loaded by sections/hg-article.liquid).
 *
 * Article HTML lists plain product links:
 *   <div class="hg-kits"><a class="hg-kit" href="/products/handle" data-note="Best first HG">HG Gundam Aerial</a> ...</div>
 * Each link becomes a card with the product's live photo, price and status, read from /products/<handle>.js,
 * so cards never go stale when stock or prices change. If a product can't be loaded the plain link stays.
 *
 * Status follows the store's tag rules: ships-now = in stock (Add to cart), dropship and available = Imported
 * (View kit only: Imported items need the consent checkbox on the product page), not available = sold out.
 */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function sized(url, width) {
    if (!url) return '';
    const u = url.startsWith('//') ? 'https:' + url : url;
    return u + (u.includes('?') ? '&' : '?') + 'width=' + width;
  }

  function status(p) {
    const tags = (p.tags || []).map((t) => String(t).toLowerCase());
    if (!p.available) return { key: 'out', label: 'Sold out' };
    if (tags.includes('preorder')) return { key: 'pre', label: 'Preorder' };
    if (tags.includes('ships-now')) return { key: 'stock', label: 'In stock: ships now' };
    return { key: 'import', label: 'Imported: 3-4 weeks' };
  }

  function card(link, p) {
    const s = status(p);
    const url = link.getAttribute('href');
    const note = link.dataset.note;
    const variant = (p.variants || []).find((v) => v.available) || (p.variants || [])[0];
    const compare = p.compare_at_price && p.compare_at_price > p.price ? `<s>${money.format(p.compare_at_price / 100)}</s>` : '';
    const action =
      s.key === 'stock' && variant
        ? `<button type="button" class="hg-kit-card__add" data-variant="${variant.id}">Add to cart</button>`
        : `<a class="hg-kit-card__view" href="${esc(url)}">${s.key === 'out' ? 'Get restock alert' : 'View kit'}</a>`;
    const el = document.createElement('article');
    el.className = `hg-kit-card hg-kit-card--${s.key}`;
    el.innerHTML = `
      <a class="hg-kit-card__media" href="${esc(url)}" tabindex="-1" aria-hidden="true">
        ${p.featured_image ? `<img src="${esc(sized(p.featured_image, 480))}" srcset="${esc(sized(p.featured_image, 240))} 240w, ${esc(sized(p.featured_image, 480))} 480w" sizes="(min-width: 750px) 220px, 45vw" alt="" loading="lazy" width="480" height="480">` : ''}
      </a>
      <div class="hg-kit-card__body">
        <span class="hg-kit-card__badge">${s.label}</span>
        <a class="hg-kit-card__title" href="${esc(url)}">${esc(p.title)}</a>
        ${note ? `<span class="hg-kit-card__note">${esc(note)}</span>` : ''}
        <span class="hg-kit-card__price">${money.format(p.price / 100)} ${compare}</span>
        ${action}
        <span class="hg-kit-card__msg" role="status" aria-live="polite"></span>
      </div>`;
    return el;
  }

  async function add(btn) {
    const msg = btn.parentElement.querySelector('.hg-kit-card__msg');
    btn.disabled = true;
    btn.textContent = 'Adding...';
    try {
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Could not add');
      btn.textContent = 'Added';
      msg.innerHTML = `Added to your cart. <a href="${root}cart">View cart</a>`;
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Add to cart';
      msg.textContent = e.message;
    }
  }

  async function upgrade(link) {
    const m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    try {
      const r = await fetch(root + 'products/' + m[1] + '.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error(r.status);
      link.replaceWith(card(link, await r.json()));
    } catch (e) {
      link.classList.add('hg-kit--plain');
    }
  }

  function init(scope) {
    scope.querySelectorAll('.hg-kits').forEach((box) => {
      box.classList.add('is-live');
      box.querySelectorAll('a.hg-kit').forEach(upgrade);
      box.addEventListener('click', (e) => {
        const btn = e.target.closest('.hg-kit-card__add');
        if (btn) add(btn);
      });
    });
  }

  window.HGKitCards = { init };
  init(document);
})();
